// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Search2: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.97 22">
            <path
                fill="currentColor"
                d="m21.87 21.44-6.3-6.38a8.92 8.92 0 0 0 2.39-6.08C17.96 4.03 13.94 0 8.98 0S0 4.03 0 8.98s4.03 8.98 8.98 8.98c2.37 0 4.52-.93 6.13-2.44l6.29 6.37c.06.06.15.1.23.1s.17-.03.23-.09c.14-.12.14-.33.01-.46zM.65 8.98C.65 4.39 4.39.65 8.98.65c4.67 0 8.33 3.66 8.33 8.33 0 4.59-3.74 8.33-8.33 8.33S.65 13.58.65 8.98z"
            />
        </svg>
    );
};

export default React.memo(Search2);